// CompanyTabs.jsx
import React, { useState, useEffect } from "react";
import api from "../../services/api";
import authService from '../../services/authService';

export default function CompanyTabs({ activeCompany, setActiveCompany }) {
  const [companies, setCompanies] = useState([]);
  const [counts, setCounts] = useState({});

  useEffect(() => {
    fetchCompanies();
  }, []);

  useEffect(() => {
    if (companies.length > 0) {
      fetchAllCounts();
    }
  }, [companies]);

  const fetchCompanies = async () => {
    try {
      const res = await authService.get("/companies");
      const companiesList = res.data || [];
      setCompanies(companiesList);
      
      // Устанавливаем первую компанию как активную по умолчанию
      if (companiesList.length > 0 && !activeCompany) {
        setActiveCompany(companiesList[0].id);
      }
    } catch (err) {
      console.error("Ошибка загрузки компаний:", err);
    }
  };

  const fetchAllCounts = async () => {
    try {
      const countsPromises = companies.map(async (company) => {
        try {
          const res = await api.get("/cutting/sheets/count", {
            params: { companyId: company.id }
          });
          return { companyId: company.id, counts: res.data };
        } catch (err) {
          console.error(`Ошибка загрузки счетчиков для компании ${company.name}:`, err);
          return { companyId: company.id, counts: { oldCount: 0, newCount: 0, totalCount: 0 } };
        }
      });

      const results = await Promise.all(countsPromises);
      const countsMap = {};
      results.forEach(({ companyId, counts }) => {
        countsMap[companyId] = counts;
      });
      setCounts(countsMap);
    } catch (err) {
      console.error("Ошибка загрузки счетчиков:", err);
    }
  };

  // Периодическое обновление счетчиков
  useEffect(() => {
    const interval = setInterval(() => {
      if (companies.length > 0) {
        fetchAllCounts();
      }
    }, 10000); // Обновление каждые 10 секунд

    return () => clearInterval(interval);
  }, [companies]);

  return (
    <div className="company-tabs mb-4">
      <ul className="nav nav-tabs">
        {companies.map((company) => {
          const companyCounts = counts[company.id] || { oldCount: 0, newCount: 0, totalCount: 0 };
          const isActive = activeCompany === company.id;
          
          return (
            <li key={company.id} className="nav-item">
              <button
                className={`nav-link ${isActive ? "active" : ""}`}
                onClick={() => setActiveCompany(company.id)}
                style={{ 
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  padding: "10px 16px",
                  position: "relative"
                }}
              >
                <span className="company-name">{company.name}</span>
                
                <span className="d-flex align-items-center gap-1">
                  {companyCounts.newCount > 0 && (
                    <span 
                      className="badge rounded-pill bg-success"
                      style={{ 
                        fontSize: "0.75rem",
                        padding: "4px 8px"
                      }}
                    >
                      {companyCounts.newCount}
                    </span>
                  )}
                  
                  {companyCounts.oldCount > 0 && (
                    <span 
                      className="badge rounded-pill bg-secondary"
                      style={{ 
                        fontSize: "0.75rem",
                        padding: "4px 8px"
                      }}
                    >
                      {companyCounts.oldCount}
                    </span>
                  )}
                </span>
              </button>
            </li>
          );
        })}
      </ul>
      
      <style jsx>{`
        .company-tabs .nav-tabs {
          border-bottom: 2px solid #dee2e6;
          gap: 4px;
        }
        
        .company-tabs .nav-link {
          border: none;
          border-bottom: 2px solid transparent;
          color: #6c757d;
          transition: all 0.2s ease;
          margin-bottom: -2px;
          background: transparent;
        }
        
        .company-tabs .nav-link:hover {
          border-bottom-color: #adb5bd;
          color: #495057;
        }
        
        .company-tabs .nav-link.active {
          border-bottom: 2px solid #007bff;
          color: #007bff;
          font-weight: 500;
        }
        
        .company-tabs .company-name {
          max-width: 150px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        
        .company-tabs .badge {
          min-width: 24px;
          text-align: center;
        }
      `}</style>
    </div>
  );
}